import { useContext } from "react";
import { ToggleMenubarContext } from "@/contexts/ToggleMenubarContext";

// ----------------------------------------------------------------------

const useToggleMenubar = () => useContext(ToggleMenubarContext);

export default useToggleMenubar;
